import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import { useStoreActions } from 'easy-peasy';
import { Form } from 'react-bootstrap';
import SelectMultipleItemsWithSearchBar from "../../widgets/selectMultipleItemsWithSearchBar/SelectMultipleItemsWithSearchBar.jsx";

import useCustomGetStoreState from '../../../hooks/useCustomGetStoreState.jsx';


import "react-datepicker/dist/react-datepicker.css";
import { useToast } from '../../../hooks/useToast.jsx';




const UpdateVideoPlaylistsComponent = forwardRef((props, ref) => {

	const { video, videoPlaylists, closeModal } = props;

	const toast = useToast();

    const { allPlaylists } = useCustomGetStoreState("playlists");
	const { updateVideoPlaylists } = useStoreActions(actions => actions.videos);

  
	const [selectedPlaylists, setSelectedPlaylists] = useState(videoPlaylists ? videoPlaylists.map(playlist => playlist.uniqueId).map(String) : []);


	const [clientsPlaylists, setClientsPlaylists] = useState([]);

	useEffect(() => {
		if (allPlaylists?.length > 0) {
			const filteredPlaylists = allPlaylists.filter(playlist =>
				playlist.isEditable
			);
			setClientsPlaylists(filteredPlaylists);
		}
	}, [allPlaylists]);


    const submitForm = () => {
	 
        const options = {
            playlistsUUIDS: selectedPlaylists,
            uniqueId: video.uniqueId
        }

		updateVideoPlaylists(options)
			.then(() => {
				closeModal();
				toast.open({ message: "Modifications réalisées avec succès", variant: "success" });
			})
    }

	useImperativeHandle(ref, () => ({
			submitForm
	}));

    return (
        <div className='formation-form'>
			<Form method="post" encType="multipart/form-data" id="formation-form" className="video_playlists_form">
				<div className="mb-4">
					<Form.Label>Playlists</Form.Label>
					<SelectMultipleItemsWithSearchBar
						idSelector="videoPlaylists"
						allItems={clientsPlaylists}
						selectedItemKeys={selectedPlaylists}
						setSelectedItemKeys={setSelectedPlaylists}
						itemKey="uniqueId" itemValue="name"
					/>
				</div>
	        </Form>
        </div>
    )
});

export default UpdateVideoPlaylistsComponent;